export const languageChangerObject = {
    'russian': {
        'navigation': {
            0: '',
            1: 'Отзывы',
            2: 'О компании',
            3: 'Услуги',
            4: 'Контакты',
        },
        'previewPage': {
            1: 'Mobile Drive —',
            2: 'Диагностика и ремонт АКПП',
            3: 'Диагностика и ремонт автоматической коробки передач в Кишинёве. Качественные работы и гарантия',
            4: 'Рассказать о проблеме',
            //5:'100% Доверенный автосервис с локацией в Кишинёве!'//
        },
        'whyUs': {
            1: 'Почему стоит выбрать нас?',
            2: 'Приемлемые цены ',
            3: 'Квалифицированный персонал',
            4: 'Персональная гарантия',
            5: 'Используем для ремонта новые запчасти',
            6: 'Маршрут к автосервису',
            7: 'Отзывы клиентов',
            8: 'Смотреть все отзывы',
            9: "15+ лет опыта работы",
            10: "Квалифицированный персонал",
            11: "Качественные запчасти для ремонта",
            12: "Собственный склад запчастей",
        },
        'shortAdd': {
            1: 'Запишитесь на проверку коробки передач',
            2: 'Машину дергает или слышны странные звуки при переключении передач? Запишитесь к нам на диагностику!',
            3: 'Записаться',
        },
        'shortAdd2': {
            1: 'Пора сменить масло в АКПП? Тогда диагностика бесплатно!',
            2: 'При замене масла и адаптации акпп, диагностика бесплатно',
            3: 'Связаться сейчас',
        },
        'aboutUs': {
            1: 'Об автосервисе',
            2: 'MOBILE-DRIVE — профессионалы в диагностике и ремонте автоматических коробок передач всех типов: классических АКПП, вариаторов (CVT) и роботизированных трансмиссий (DSG/Tiptronic).',
            9: 'Мы используем современное оборудование, профильные сканеры и многолетний опыт наших мастеров, чтобы восстановить чёткую и плавную работу вашей трансмиссии.',
            //10: 'У нас есть всё для того чтобы выполнить ремонт гидравлической системы автомобиля качественно, мы справимся с любой задачей!',
            11: 'Посмотрите наши работы:',
            12: 'Фото отчёты'
        },
        'contactsPage': {
            'form': {
                1: 'Или опишите вашу проблему и мы вам перезвоним',
                2: 'Ваш номер телефона*',
                3: 'Ваше имя',
                4: 'Андрей...',
                5: 'Укажите модель и год вашего авто',
                6: 'Opel astra J, 2018 года, передний привод',
                7: 'Расскажите нам о вашей проблеме',
                8: 'Например: Слышен стук при переключении передачи, помогите решить проблему',
                9: 'Ваша заявка была отправлена! Мы вам перезвоним.',
                10: 'Отправить',
                11: '* Это поле обязательно для заполнения',
				details: 'Для детальной консультации, позвоните нам прямо сейчас!',
            },
            'contacts': {
                1: 'Контакты',
                2: 'г. Кишинёв, ул. Тудор Владимиреску 1А',
                3: 'Пн-Пт: 9.00 — 18.00',
				requisites: 'Банковские реквизиты:'
            },
            'bank-details_header': {
                1: 'Rechizite bancare:',
                2: 'mun. Chisinau, sec. Ciocana, str. Milescu Spătaru 18',
                3: 'Lu-Vi: 9.00 — 18.00',
            },
            'form-info': {
                1: 'sss',
            },
        },
        'restorationLocale': {
            1: 'Наши услуги',
        },
        'QALocale': {
            oftenAsked: 'Часто задаваемые вопросы',
            newRack: 'Какие признаки указывают на неисправность АКПП?',
            newRackDescription: 'Основные признаки — рывки при переключении передач, пробуксовка, посторонние шумы, запах гари, утечка масла и включение аварийного режима коробки.',
            signsOfBroken: 'Можно ли продолжать ездить с проблемной коробкой?',
            signsOfBrokenDescription: 'Нет, это может привести к серьёзному и дорогостоящему повреждению трансмиссии. Лучше сразу обратиться в сервис для диагностики.',
            qaQuestion1: 'Сколько стоит ремонт АКПП?',
            qaQuestion1Description: 'Цена зависит от марки автомобиля и характера поломки. Диагностика поможет точно определить объем работ и стоимость. Примерный диапазон — от 4000 до 30 000 леев.',
            qaQuestion2: 'Сколько времени занимает ремонт?',
            qaQuestion2Description: 'Обычно от 1 до 5 рабочих дней. Всё зависит от сложности работ и наличия необходимых запчастей.',
            qaQuestion3: 'Даёте ли вы гарантию на ремонт АКПП?',
            qaQuestion3Description: 'Да, на все работы и установленные запчасти предоставляется гарантия — до 6 месяцев или 10 000 км пробега.',
            qaQuestion4: 'Нужно ли менять масло в автоматической коробке передач?',
            qaQuestion4Description: 'Да, даже при отсутствии проблем рекомендуется менять масло каждые 40 000–60 000 км, чтобы продлить срок службы коробки.',
            qaQuestion5: 'Делаете ли вы адаптацию АКПП после замены масла?',
            qaQuestion5Description: 'Да, мы проводим адаптацию коробки после замены масла, чтобы она работала корректно под ваш стиль вождения.',
            qaQuestion6: 'Доп Вопрос 6',
            qaQuestion6Description: 'Доп 6 описание',
            qaQuestion7: 'Доп Вопрос 7',
            qaQuestion7Description: 'Доп 7 описание',
            qaQuestion8: 'Доп Вопрос 8',
            qaQuestion8Description: 'Доп 8 описание',
        },
        'footer': {
            1: 'Сайт разработан при поддержке',
            2: ' при поддержке '
        }
    },
    'romanian': {
        'navigation': {
            0: '',
            1: 'Recenzii',
            2: 'Despre companie',
            3: 'Servicii',
            4: 'Contacte',
        },
        'previewPage': {
            1: 'Mobile Drive —',
            2: 'Diagnostica și reparația transmisiei automate',
            3: 'Diagnostica și repararea transmisiei automate în Chișinău. Lucrări calitative și garanție',
            4: 'Descrie-ne problema ta',
            //5:'service auto de Încredere cu locație în Chișinău!'
        },
        'whyUs': {
            1: 'De ce trebuie să ne alegi?',
            2: 'Prețuri rezonabile',
            3: '-',
            4: 'Personal calificat',
            5: 'Piese de schimb calitative',
            6: 'Vezi locația',
            7: 'Recenziile clienților',
            8: 'Toate recenziile',
            9: "15+ ani de experiență",
            10: "Personal calificat",
            11: "Piese de schimb calitative",
            12: "Propriu depozit de piese",
        },
        'shortAdd': {
            1: "Programează-te pentru verificarea cutiei de viteze",
            2: "Mașina vibrează sau se aud sunete ciudate la schimbarea treptelor? Programează-te la diagnosticare!",
            3: "Programează-te",
        },
        'shortAdd2': {
            1: "Vreai să schimbi uleiul în cutia automată? Diagnosticare gratuită!",
            2: "La schimbul de ulei și adaptarea cutiei automate, diagnosticarea este gratuită",
            3: "Contactează-ne acum",
        },
        'aboutUs': {
            1: 'Despre autoservice',
            2: "MOBILE-DRIVE — profesioniști în diagnosticarea și reparația cutiilor de viteze automate de toate tipurile: cutii automate clasice (AT), variatoare (CVT) și transmisii robotizate (DSG/Tiptronic).",
            9: "Folosim echipamente moderne, scannere specializate și experiența vastă a meșterilor noștri pentru a reda funcționarea precisă și lină a transmisiei dumneavoastră.",
            //10: "Avem tot ce este necesar pentru a efectua reparația sistemului hidraulic al mașinii la cel mai înalt nivel. Orice provocare este pentru noi doar o nouă oportunitate de a demonstra expertiza noastră!",
            11: 'Vezi lucrările noastre:',
            12: 'Foto raporturi',
        },
        'contactsPage': {
            'form': {
                1: 'Sau descrie-ne problema ta și te sunăm înapoi',
                2: 'Telefonul tău*',
                3: 'Nume',
                4: 'Andrei...',
                5: 'Modelul și anul automobilului',
                6: 'Opel astra J, 2018 anul, tracțiune față',
                7: 'Descrie-ne problema ta',
                8: 'Exemplu: Se aude un zgomot când schimb viteza, vă rog să mă ajutați să rezolv problema.',
                9: 'Cererea a fost trimisă! Așteaptă un sunet',
                10: 'Trimite',
                11: '* Este necesar să completezi măcar acest câmp',
				details: 'Pentru o consultanță detaliată, sunați-ne chiar acum!',
            },
            'contacts': {
                1: 'Contacte',
                2: 'mun. Chisinau, str. Tudor Vladimirescu 1A',
                3: 'Lu-Vi: 9.00 — 18:00',
				requisites: 'Datele bancare:'
            },
            'bank-details': {
                1: 'Rechizite bancare:',
                2: 'mun. Chisinau, sec. Ciocana, str. Milescu Spătaru 18',
                3: 'Lu-Vi: 8:30 — 18:00',
            },
            'form-info': {
                1: 'sss',
            }
        },
        'restorationLocale': {
            1: 'Serviciile noastre',
        },
        'QALocale': {
            oftenAsked: 'Întrebări frecvente',
            newRack: 'Ce semne indică o defecțiune a cutiei automate?',
            newRackDescription: 'Semnele principale sunt: smucituri la schimbarea treptelor, patinaj, zgomote ciudate, miros de ars, scurgeri de ulei și activarea modului de avarie al cutiei.',
            signsOfBroken: ' Pot continua să conduc cu o cutie de viteze defectă?',
            signsOfBrokenDescription: 'Nu, acest lucru poate duce la deteriorări grave și costisitoare ale transmisiei. Este mai bine să mergeți imediat la service pentru diagnosticare.',
            qaQuestion1: 'Cât costă reparația unei cutii automate?',
            qaQuestion1Description: 'Prețul depinde de marca mașinii și de natura defecțiunii. Diagnosticarea va ajuta la determinarea exactă a volumului de lucru și a costului. Intervalul orientativ este între 4000 și 30 000 lei.',
            qaQuestion2: 'Cât durează reparația?',
            qaQuestion2Description: 'De obicei între 1 și 5 zile lucrătoare. Totul depinde de complexitatea lucrărilor și de disponibilitatea pieselor necesare.',
            qaQuestion3: 'Oferiți garanție pentru reparația cutiei de viteze?',
            qaQuestion3Description: 'Da, oferim garanție pentru toate lucrările și piesele instalate — până la 6 luni sau 10 000 km parcurși.',
            qaQuestion4: 'Trebuie schimbat uleiul din cutia automată?',
            qaQuestion4Description: 'Da, chiar dacă nu apar probleme, se recomandă schimbarea uleiului la fiecare 40 000–60 000 km pentru a prelungi durata de viață a cutiei.',
            qaQuestion5: 'Faceți adaptarea cutiei după schimbul de ulei?',
            qaQuestion5Description: 'Da, efectuăm adaptarea cutiei după schimbul de ulei pentru ca aceasta să funcționeze corect în funcție de stilul dvs. de condus.',
            qaQuestion6: 'Доп Вопрос 6',
            qaQuestion6Description: 'Доп 6 описание',
            qaQuestion7: 'Доп Вопрос 7',
            qaQuestion7Description: 'Доп 7 описание',
            qaQuestion8: 'Доп Вопрос 8',
            qaQuestion8Description: 'Доп 8 описание',
        },
        'footer': {
            1: 'Site-ul a fost dezvoltat de către',
            2: " cu suportul "
        }
    }
}